import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=60042bc1&scoped=true&"
import script from "./DetailHeader.vue?vue&type=script&lang=js&"
export * from "./DetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=60042bc1&prod&lang=scss&scoped=true&"
import style1 from "./DetailHeader.vue?vue&type=style&index=1&id=60042bc1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60042bc1",
  null
  
)

export default component.exports